var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 12.6667C13.307 12.6667 16.0003 9.97333 16.0003 6.66667C16.0003 3.36 13.307 0.666666 10.0003 0.666666C6.69366 0.666666 4.00033 3.36 4.00033 6.66667C4.00033 9.97333 6.69366 12.6667 10.0003 12.6667ZM10.0003 3.33333C11.8403 3.33333 13.3337 4.82667 13.3337 6.66667C13.3337 8.50667 11.8403 10 10.0003 10C8.16033 10 6.66699 8.50667 6.66699 6.66667C6.66699 4.82667 8.16033 3.33333 10.0003 3.33333Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0003 14H6.00033C3.05366 14 0.666992 16.3867 0.666992 19.3333V20.6667C0.666992 23.6133 3.05366 26 6.00033 26H14.0003C16.947 26 19.3337 23.6133 19.3337 20.6667V19.3333C19.3337 16.3867 16.947 14 14.0003 14ZM16.667 20.6667C16.667 22.1333 15.467 23.3333 14.0003 23.3333H6.00033C4.53366 23.3333 3.33366 22.1333 3.33366 20.6667V19.3333C3.33366 17.8667 4.53366 16.6667 6.00033 16.6667H14.0003C15.467 16.6667 16.667 17.8667 16.667 19.3333V20.6667Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMy);
export default __webpack_public_path__ + "static/media/my.7b89519af20ad2094974a3e368a7fa3c.svg";
export { ForwardRef as ReactComponent };